module.exports = __webpack_public_path__ + "static/img/20.d6014a30.jpg";